export const isTruthyValue = value => {
  if (typeof value === 'boolean') return value;
  if (typeof value === 'number') return value > 0;
  if (typeof value === 'string') return value.trim().length > 0;
  return false;
};

export const BILLING_SETUP_CHANGED_EVENT = 'gitme:billing-setup-changed';

export const notifyBillingSetupChanged = profileResponse => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(
    new CustomEvent(BILLING_SETUP_CHANGED_EVENT, {
      detail: profileResponse || null
    })
  );
};

const isConfiguredPlanValue = value => {
  if (value === undefined || value === null) return false;
  if (typeof value === 'number') return value >= 0;
  return typeof value === 'string' && value.trim().length > 0;
};

export const resolveIntegrationCompleted = user => {
  const leadType = user?.leadType;

  if (Array.isArray(leadType)) {
    return leadType.filter(Boolean).length > 0;
  }

  if (typeof leadType === 'string') {
    return (
      leadType
        .split(',')
        .map(item => item.trim())
        .filter(Boolean).length > 0
    );
  }

  return false;
};

export const resolvePlanCompleted = user =>
  isTruthyValue(user?.planConfigured) ||
  isTruthyValue(user?.hasPlanConfigured) ||
  isTruthyValue(user?.hasPlan) ||
  isConfiguredPlanValue(user?.planId) ||
  isConfiguredPlanValue(user?.plan_id) ||
  isConfiguredPlanValue(user?.plan);

export const resolvePaymentCompleted = user =>
  isTruthyValue(user?.hasPaymentMethod) ||
  isTruthyValue(user?.paymentMethodAdded) ||
  isTruthyValue(user?.paymentConfigured) ||
  isTruthyValue(user?.hasCard) ||
  isTruthyValue(user?.paymentMethodCount);

export const resolvePlanCompletedFromResponse = response => {
  if (typeof response?.setup?.plan_configured === 'boolean') {
    return response.setup.plan_configured;
  }
  return [
    response?.settings?.plan_id,
    response?.settings?.planId,
    response?.plan_id,
    response?.planId
  ].some(isConfiguredPlanValue);
};

export const resolvePaymentCompletedFromResponse = response => {
  if (typeof response?.setup?.payment_configured === 'boolean') {
    return response.setup.payment_configured;
  }
  return (
    response?.setup?.plan_configured === true &&
    response?.setup?.payment_required === false
  );
};

export const resolveSetupProgressState = ({
  user,
  planResponse,
  paymentResponse,
  profileResponse
} = {}) => {
  const hasIntegration = resolveIntegrationCompleted(user);
  const planConfigured =
    resolvePlanCompleted(user) ||
    resolvePlanCompletedFromResponse(profileResponse || planResponse);
  const paymentMethodAdded =
    resolvePaymentCompleted(user) ||
    resolvePaymentCompletedFromResponse(profileResponse || paymentResponse);

  return {
    hasIntegration,
    planConfigured,
    paymentMethodAdded,
    hasCompletedRequiredSteps:
      hasIntegration && planConfigured && paymentMethodAdded
  };
};
